import { IORGDataTableQueryState } from 'shared-it-appmod-ui';
import { RequestStatus } from 'src/constants';
import { getUser } from 'src/libraries/auth.library';
import { httpClient, commonClient } from 'src/libraries/http.library';
import {
  CostCenterSchema,
  RequestSchema,
  RequestListSchema,
  RequestFiltersSchema,
  WOIONumberSchema,
  RequestInformationSchema,
} from 'src/models/request.model';

const http = httpClient();
const common = commonClient();

const services = {
  filterGET: async () => {
    return http.get('/requestFilters', {}, RequestFiltersSchema);
  },

  listGET: async (data: Partial<IORGDataTableQueryState> = {}) => {
    const params: Record<string, any> = {
      ...data,
    };
    if (params.order) {
      params.order = params.order === 'ascending' ? 'asc' : 'desc';
    }
    return http.get('/requests', params, RequestListSchema);
  },

  dataGET: async (id, type) => {
    return http.get(`requests/${type}/${id}`, {}, RequestSchema);
  },

  createPatrolPassengerPOST: async (data) => {
    return http.post('/requests/patrolPassenger', data, RequestSchema);
  },

  updatePatrolPassengerPUT: async (requestId, data) => {
    return http.put(
      `/requests/patrolPassenger/${requestId}`,
      data,
      RequestSchema
    );
  },

  createPatrolPassengerContractorPOST: async (data) => {
    return http.post(
      '/requests/patrolPassengerContractor',
      data,
      RequestSchema
    );
  },

  updatePatrolPassengerContractorPUT: async (requestId, data) => {
    return http.put(
      `/requests/patrolPassengerContractor/${requestId}`,
      data,
      RequestSchema
    );
  },

  createConstructionPOST: async (data) => {
    return http.post('/requests/construction', data, RequestSchema);
  },

  updateConstructionPUT: async (requestId, data) => {
    return http.put(`/requests/construction/${requestId}`, data, RequestSchema);
  },

  createConstructionContractorPOST: async (data) => {
    return http.post('/requests/constructionContractor', data, RequestSchema);
  },

  updateConstructionContractorPUT: async (requestId, data) => {
    return http.put(
      `/requests/constructionContractor/${requestId}`,
      data,
      RequestSchema
    );
  },

  verifyCostCenterGET: async (data) => {
    return common.get(
      `/getCostCenter?cost_center=${data}`,
      {},
      CostCenterSchema
    );
  },

  verifyWorkOrderGET: async (data) => {
    return common.get(
      `/validateWorkOrder?workOrderNbr=${data}`,
      {},
      WOIONumberSchema
    );
  },

  verifyIONumberGET: async (data) => {
    return common.get(
      `/validateIONumber?ioNumber=${data}`,
      {},
      WOIONumberSchema
    );
  },

  createDroneInternalPOST: async (data) => {
    return http.post('/requests/droneInternal', data, RequestSchema);
  },

  createDroneExternalPOST: async (data) => {
    return http.post('/requests/droneExternal', data, RequestSchema);
  },

  updateDroneInternalPUT: async (requestId, data) => {
    return http.put(`/requests/droneInternal/${requestId}`, data, RequestSchema);
  },

  updateDroneExternalPUT: async (requestId, data) => {
    return http.put(`/requests/droneExternal/${requestId}`, data, RequestSchema);
  },

  updateStatusPUT: async (
    requestId: number,
    requestStatus: RequestStatus,
    reason: string
  ) => {
    const user = getUser();
    const reasonBy = `${user?.first_name} ${user?.last_name}`;
    return http.put(
      `/requests/${requestId}/status`,
      {
        requestStatus,
        reason,
        reasonBy,
      },
      RequestInformationSchema
    );
  },

  updateFlightCostPUT: async (requestId: number, flightCost: string) => {
    return http.put(
      `/requests/${requestId}/cost`,
      {
        flightCost,
      },
      RequestInformationSchema
    );
  },
};

export default services;
